"use client";
import useFancybox from "@/lib/fancybox";

interface FancyboxContainerProps {
	children: React.ReactNode;
}

const FancyboxContainer: React.FC<FancyboxContainerProps> = ({ children }) => {
	const [fancyboxRef] = useFancybox({
		// Your custom options
	});

	return <div ref={fancyboxRef}>{children}</div>;
};

export default FancyboxContainer;
